/* eslint frontbucket-patterns/no-new-emotion-styled: "warn" */
import styled from '@emotion/styled';

import { gridSize, colors, borderRadius } from '@atlaskit/theme';
import { token } from '@atlaskit/tokens';
import { media } from '@atlassian/bitkit-responsive';

import { CenteredRow } from 'src/styles';
import { overflowEllipsis } from 'src/styles/mixins';

export { CurrentEntryPathSegment, LinkedPathSegment } from './path.style';

const colPaddingFileSize = gridSize() * 2;
const colWidthIcon = gridSize() * 3;
const colWidthFileSize = gridSize() * 9;
const colWidthCommitMessage = gridSize() * 30;
const colWidthCommitDate = gridSize() * 14;

export const DirectoryListRow = styled.tr`
  & > td {
    padding-bottom: ${gridSize()}px;
    padding-top: ${gridSize()}px;
  }

  &:hover,
  &:focus {
    background-color: ${token('elevation.surface.raised.hovered', colors.N20)};
    box-shadow: ${token(
      'elevation.shadow.raised',
      `-${gridSize() / 2}px 0 0 0 ${colors.N20},
      ${gridSize() / 2}px 0 0 0 ${colors.N20}`
    )};
    border-radius: ${borderRadius()}px;
  }
`;

export const DirectoryList = styled.div`
  padding-bottom: ${gridSize() * 4}px;
`;

export const ItemSizeHeader = styled.th`
  color: ${token('color.text.subtlest', colors.N300)};
  min-width: ${colWidthFileSize}px;
  padding-right: ${colPaddingFileSize}px;
  text-align: right;
  width: ${colWidthFileSize}px;
`;

export const ItemCommitDateHeader = styled.th`
  color: ${token('color.text.subtlest', colors.N300)};
  min-width: ${colWidthCommitDate}px;
  width: ${colWidthCommitDate}px;
`;

export const ItemIconCell = styled.td`
  min-width: ${colWidthIcon}px;
  width: ${colWidthIcon}px;
`;

// Can't create a `styled(Link)` because Flow doesn't think `Link`
// is a React$Component
export const ItemNameHeader = styled.th`
  color: ${token('color.text.subtlest', colors.N300)};
`;

export const ItemNameCell = styled.td`
  max-width: 500px;

  a,
  a:hover,
  a:focus {
    color: ${token('color.text', colors.N800)};
  }
`;

export const ItemSizeCell = styled.td`
  padding-right: ${colPaddingFileSize}px;
  text-align: right;
`;

export const ItemMessageHeader = styled.th`
  font-weight: bold;
  color: ${token('color.text.subtlest', colors.N300)};
`;

export const ItemCommitMessageCell = styled.td`
  ${overflowEllipsis(`${colWidthCommitMessage}px`)};
  min-width: ${colWidthCommitMessage}px;
`;

export const ItemIcon = styled.div`
  align-items: center;
  display: flex;
  justify-content: center;

  /* stylelint-disable no-descending-specificity */
  a,
  a:hover,
  a:focus {
    color: inherit;
  }
  /* stylelint-enable */
`;

export const PathHeader = styled.div`
  display: flex;
  align-items: flex-start;
`;

export const DirectoryHeader = styled.div`
  margin: ${gridSize() * 2}px 0 ${gridSize()}px;
  padding-top: ${gridSize() / 4}px;
  padding-bottom: ${gridSize() / 4}px;
`;

export const IconWrapper = styled.div`
  flex-shrink: 0;
  line-height: 0;
`;

export const PathWrapper = styled.span`
  font: ${token('font.body.large')};
  margin-left: ${gridSize()}px;

  /* Override @atlaskit/panel styles */
  text-transform: none;
`;

export const SubtleLink = styled.a`
  color: inherit;
  display: block;
`;

// Set the max-width to 600px for the DirectoryFilter on the Source page to make RefSelectorWrapper responsive
// 600px = RefSelectorWrapper max-width 400px + Input filter width 184px and margin-left 16px.
export const DirectoryFilter = styled.div`
  display: flex;
  align-items: center;
  max-width: ${gridSize() * 75}px;

  /* Spacing between AK component */
  > div + div {
    margin-left: ${gridSize() * 2}px;
  }

  ${media.upToSmall(`
    flex-direction: column;
    align-items: flex-start;

    & > div + div {
    margin-left: 0;
    width: 100%;
  }
  `)}
`;

export const ListFooter = styled(CenteredRow)`
  padding: ${gridSize()}px 0;
`;

export const FilterMessage = styled.span`
  align-self: center;
  display: inline-block;
  margin-left: ${gridSize()}px;
`;

export const LinkInnerWrapper = styled.span`
  display: inline-flex;
  align-items: center;
  max-width: 100%;
`;

export const LinkIconContainer = styled.span`
  display: inline-block;
  flex-shrink: 0;
  margin-right: ${gridSize() * 2}px;
`;

export const LinkTextContainer = styled.span`
  flex-grow: 1;
  ${overflowEllipsis()};
`;
